import { defineStore } from 'pinia';

import { MemberCapability } from '@/helpers/member-capability';

import { useMemberStore } from './member';

type CapabilityState = {
    capabilities: Set<MemberCapability>;
};

export const useCapabilityStore = defineStore('capability', {
    state: (): CapabilityState => ({
        capabilities: new Set(),
    }),
    getters: {
        hasCapability:
            (state: CapabilityState) =>
            (capability: MemberCapability): boolean =>
                state.capabilities.has(capability),
    },
    actions: {
        sync() {
            const memberStore = useMemberStore();
            this.capabilities = new Set(memberStore.member?.capabilities ?? []);
        },
    },
});
